'use client';

import Logo from '@/components/Logo';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import { useTranslation } from '../app/i18n/client';
import AppContext from './AppContext';
import Copyright from './Copyright';

export default function NotFound() {
  const { i18n } = useContext(AppContext);
  const { t } = useTranslation(i18n?.lng);

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'start',
          alignItems: 'center',
          height: '100vh',
          minHeight: '100vh',
        }}
      >
        <Box
          sx={{
            my: 4,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom>
            <Logo />
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 'auto',
            mb: 6,
            textAlign: 'center',
          }}
        >
          <Typography variant="h4" component="h1">
            {t('Not Found')}
          </Typography>
          <Typography variant="subtitle1" component="h2">
            {t('Could not find requested resource')}
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 'auto',
            mb: 6,
          }}
        >
          <Copyright />
        </Box>
      </Box>
    </Container>
  );
}
